import * as React from "react";
import { Combobox, type ComboboxProps } from "./combobox";

export interface RoleSelectorProps extends Omit<
  ComboboxProps,
  "options" | "multiple" | "onChange"
> {
  roles: { id: string; name: string }[];
  onChange?: (value: string | undefined) => void;
}

const RoleSelector = React.forwardRef<HTMLButtonElement, RoleSelectorProps>(
  (
    {
      roles,
      onChange,
      placeholder = "Select role...",
      searchPlaceholder = "Search roles...",
      emptyMessage = "No roles found.",
      ...props
    },
    ref,
  ) => {
    const options = React.useMemo(
      () =>
        roles.map((role) => ({
          value: role.id,
          label: role.name,
        })),
      [roles],
    );

    const handleChange = React.useCallback(
      (val: string | string[] | undefined) => {
        onChange?.(typeof val === "string" ? val : undefined);
      },
      [onChange],
    );

    return (
      <Combobox
        ref={ref}
        options={options}
        onChange={handleChange}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        emptyMessage={emptyMessage}
        {...props}
      />
    );
  },
);
RoleSelector.displayName = "RoleSelector";

export { RoleSelector };
